import { render, staticRenderFns } from "./DashboardVentasSinActividad.vue?vue&type=template&id=34d9acad&scoped=true&lang=pug"
import script from "./DashboardVentasSinActividad.vue?vue&type=script&lang=js"
export * from "./DashboardVentasSinActividad.vue?vue&type=script&lang=js"
import style0 from "./DashboardVentasSinActividad.vue?vue&type=style&index=0&id=34d9acad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d9acad",
  null
  
)

export default component.exports